import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
declare var $: any;

@Component({
  selector: 'date-time-picker',
  templateUrl: './date-time-picker.component.html',
  styleUrls: ['./date-time-picker.component.css']
})

export class DateTimePickerComponent implements OnInit {
  private hours: string[] = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10',
    '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'];

  private minutes: string[] = [
    '00', '01', '02', '03', '04', '05', '06', '07', '08', '09',
    '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
    '20', '21', '22', '23', '24', '25', '26', '27', '28', '29',
    '30', '31', '32', '33', '34', '35', '36', '37', '38', '39',
    '40', '41', '42', '43', '44', '45', '46', '47', '48', '49',
    '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'
  ];

  public selectedHour: string = "";
  public selectedMinutes: string = "";
  public selectedDate: string = "";

  @Input()
  private selectedDateTime: string;

  @ViewChild('dateSelect', { static: false }) public dateSelect: ElementRef<HTMLInputElement>;
  @ViewChild('hoursSelect', { static: false }) public hoursSelect: ElementRef<HTMLSelectElement>;
  @ViewChild('minutesSelect', { static: false }) public minutesSelect: ElementRef<HTMLSelectElement>;

  constructor() { }

  ngOnInit() {
    let that = this;
    let datePickerInput = $('.date-input');
    let selectHoursInput = $('.selectHours');
    let selectMinutesInput = $('.selectMinutes');

    datePickerInput.datepicker({
      format: "dd.mm.yyyy",
      weekStart: 1,
      maxViewMode: 2,
      todayBtn: "linked",
      clearBtn: true,
      autoclose: true,
      todayHighlight: true
    });

    datePickerInput.on('change', function (e) {
      that.selectedDate = that.dateSelect.nativeElement.value;
    });

    selectHoursInput.on('change', function (e) {
      that.selectedHour = that.hoursSelect.nativeElement.value;
    });

    selectMinutesInput.on('change', function (e) {
      that.selectedMinutes = that.minutesSelect.nativeElement.value;
    });

    if (this.selectedDateTime !== undefined) {
      let dateTimeArr = this.selectedDateTime.split(' ');
      let date = dateTimeArr[0];
      let timeArr = dateTimeArr[1].split(':');
      let hours = timeArr[0];
      let minutes = timeArr[1];

      this.selectedDate = date;
      this.selectedHour = hours;
      this.selectedMinutes = minutes;
    }
  }

  public createScheduleString() {
    let selectedDateArray = this.selectedDate.split('.');
    let date = selectedDateArray[0];
    let month = selectedDateArray[1];
    let year = selectedDateArray[2];
    let formatedDate = year + '-' + month + '-' + date;

    return formatedDate + ' ' + this.selectedHour + ':' + this.selectedMinutes + ':00';
  }

  public getScheduleDate() {
    let monthNames: string[] = [
      "January", "February", "March",
      "April", "May", "June", "July",
      "August", "September", "October",
      "November", "December"
    ];

    let selectedDateArray = this.selectedDate.split('.');
    let date = selectedDateArray[0];
    let month = parseInt(selectedDateArray[1]);
    let year = selectedDateArray[2];
    let amOrPm = parseInt(this.selectedHour) > 11 ? 'pm' : 'am';

    return monthNames[month - 1] + ' ' + date + ' ' + year + ', ' + this.selectedHour + ':' + this.selectedMinutes + ' ' + amOrPm;
  }
}
